module.exports = "<button\n  class=\"btn-icon\"\n  [ngClass]=\"classes\"\n  [type]=\"type\">\n  <i [ngClass]=\"icon\"></i>\n</button>\n"